{
  "markread": "Marker som lest",
  "newest": "Nyeste",
  "unread": "Ulest",
  "starred": "Stjernemerket",
  "tags": "Etiketter",
  "alltags": "Alle etiketter",
  "timestamp": "{0,date} {0,time}",
  "hours": "for {0,plural,one {én time},other {# timer}} ago",
  "minutes": "for {0,plural,one {ett minutt},other {# minutter}} ago",
  "seconds": "for {0,plural,one {ett sekund},other {# sekunder}} siden",
  "star": "Stjernemerk",
  "unstar": "Fjern stjerne",
  "mark": "Marker som lest",
  "unmark": "Marker som ulest",
  "load_img": "Vis bilder",
  "open_window": "Åpne",
  "searchbutton": "Søk",
  "sources": "Kilder",
  "source_add": "Legg til kilde",
  "source_opml": "eller importer en OPML-fil",
  "source_export": "Eksporter kilder",
  "source_edit": "Endre",
  "source_delete": "Slett",
  "source_warn": "Vil du virkelig fjerne denne kilden?",
  "source_new": "Ny ulagret kilde",
  "source_title": "Tittel",
  "source_tags": "Etiketter",
  "source_comma": "Kommainndelt",
  "source_select": "Velg kilde",
  "source_type": "Type",
  "source_save": "Lagre",
  "source_cancel": "Avbryt",
  "source_saved": "Lagret",
  "no_entries": "Ingen data funnet",
  "more": "Mer",
  "login": "Logg inn",
  "login_username": "Brukernavn",
  "login_password": "Passord",
  "filter": "Filtrer",
  "days": "{0,plural,zero {i dag},one {i går},other {# dager siden}}",
  "next": "Neste",
  "searchremove": "Skjul søk",
  "refreshbutton": "Gjenoppfrisk kilder",
  "settingsbutton": "Innstillinger",
  "logoutbutton": "Logg ut",
  "loginbutton": "Logg inn",
  "source_filter": "Filter",
  "source_autotitle_hint": "La stå tom for å hente tittel",
  "source_pwd_placeholder": "Ikke endret",
  "source_last_post": "Siste post sett",
  "source_refresh": "Gjenoppfrisk denne kilden",
  "login_invalid_credentials": "Feil brukernavn/passord",
  "no_title": "Ingen tittel",
  "error": "En feil inntraff",
  "streamerror": "Ingen elementer ble lastet inn, gjeninnlast?",
  "reload_list": "Gjeninnlast liste",
  "sources_refreshed": "Kilder gjeninnlastet",
  "error_session_expired": "Økt utløpt",
  "error_add_source": "Kunne ikke legge til kilde:",
  "error_delete_source": "Kunne ikke slette kilde:",
  "error_load_tags": "Kunne ikke laste inn etiketter:",
  "error_unknown_tag": "Ukjent etikett:",
  "error_unknown_source": "Ukjent kilde-ID:",
  "error_mark_items": "Kan ikke merke alle synlige elementer:",
  "error_mark_item": "Kan ikke merke/oppheve merking av element:",
  "error_star_item": "Kan ikke stjernemerke/oppheve stjernemerking av element:",
  "error_logout": "Kunne ikke logge ut:",
  "error_loading": "Innlastingsfeil:",
  "error_loading_stats": "Kan ikke laste navigeringsstatistikk:",
  "error_saving_color": "Kan ikke lagre ny farge:",
  "error_refreshing_source": "Kan ikke gjenoppfriske kilder:",
  "error_sync": "Kunne ikke synkronisere siste endringer fra tjener:",
  "error_invalid_subsection": "Ugyldig underdel:",
  "online_count": "Elementer tilgjengelige på tjeneren",
  "offline_count": "Elementer tilgjengelige lokalt",
  "login_offline": "Frakoblet lagring",
  "app_update": "selfoss har blitt oppdatert, last inn på ny",
  "app_reload": "Gjeninnlast",
  "error_offline_storage": "Lagringsfeil for frakoblet lagring: {0}. Gjeninnlasting kan hjelpe. Skrur av frakoblet imens.",
  "search_label": "Søketekst",
  "article_actions": "Handlinger",
  "error_configuration": "Kunne ikke laste inn oppsett.",
  "info_url_copied": "Nettadresse kopiert til utklippstavle.",
  "share_native_label": "Del",
  "share_diaspora_label": "Del på Diaspora",
  "share_twitter_label": "Del på Twitter",
  "share_facebook_label": "Del på Facebook",
  "share_pocket_label": "Del til Pocket",
  "share_wallabag_label": "Lagre på Wallabag",
  "share_wordpress_label": "Lagre på WordPress",
  "share_mail_label": "Del ved bruk av e-post",
  "share_copy_label": "Kopier lenke til utklippstavle",
  "error_share_native_abort": "Kunne ikke dele element, enten finnes det ingen delingsmål, eller du har avbrutt deling.",
  "error_share_native": "Kunne ikke dele element.",
  "close_entry": "Lukk",
  "error_unwritable_logs": "Kunne ikke loggføre.",
  "error_check_log_file": "En feil inntraff, sjekk loggfilen “{0}”.",
  "error_check_system_logs": "En feil inntraff, sjekk systemloggene dine.",
  "offline_navigation_unavailable": "Å bytte etiketter og kilder støttes foreløpig ikke i frakoblet modus.",
  "error_offline_storage_not_available": "Frakoblet lager ikke tilgjengelig. Sørg for at din nettleser {0}støtter IndexedDB-API-et{1}, samt at du ikke bruker incognito-modus i en Chrome-basert nettleser.",
  "error_edit_source": "Kunne ikke lagre kildeendringer:",
  "article_reading_time": "{0} min å lese",
  "experimental": "Eksperimentell",
  "sources_leaving_unsaved_prompt": "Forlat innstillinger med ulagrede kildeendringer?",
  "source_warn_cancel_dirty": "Forkast ulagrede endringer?"
}
